document.addEventListener("DOMContentLoaded", function () {
  let selectedDesignsForDeletion = []; // store IDs of selected designs for bulk delete
  const bulkDesignDeleteBtn = document.getElementById("bulk-design-delete-btn");

  function loadPreviousDesign(previousDesigns) {
    if (previousDesigns.length === 0) {
      return false;
    }

    const container = document.querySelector(
      ".load-custom-disc-preview-container"
    );

    container.innerHTML = ""; // Clear existing content
    previousDesigns.forEach((design) => {
      let { src, json, id } = design;
      const wrapper = document.createElement("div");
      wrapper.classList.add("preview-image-wrapper");

      // Checkbox for multi-select
      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.value = id;
      checkbox.classList.add("design-checkbox");
      checkbox.addEventListener("change", () => {
        if (checkbox.checked) {
          selectedDesignsForDeletion.push(id);
        } else {
          selectedDesignsForDeletion = selectedDesignsForDeletion.filter(
            (dId) => dId !== id
          );
        }

        // ✅ Show or hide the delete button
        if (selectedDesignsForDeletion.length > 0) {
          bulkDesignDeleteBtn.classList.add("active");
        } else {
          bulkDesignDeleteBtn.classList.remove("active");
        }
      });

      const img = document.createElement("img");
      img.classList.add("preview-image");
      img.src = design.src;
      img.alt = "Design Image Preview";
      img["data-json"] = json;

      // Attach click handler to select
      img.addEventListener("click", () => {
        document
          .querySelectorAll(
            ".load-custom-disc-preview-container .preview-image"
          )
          .forEach((el) => el.classList.remove("selected"));
        img.classList.add("selected");

        window.selectedDesign = { json, src, id };

        UseSavedDesignBtn.classList.remove("!hidden");
      });

      img.addEventListener("dblclick", function () {
        // Your logic here
        window.handleUseSavedDesignAction();
      });

      // Delete icon
      const delBtn = document.createElement("span");
      delBtn.innerHTML = "✕"; // or use an icon (e.g., FontAwesome)
      delBtn.classList.add("delete-design-icon");

      // Delete handler
      delBtn.addEventListener("click", async (e) => {
        e.stopPropagation();

        if (!confirm("Are you sure to delete?")) {
          return false;
        }
        let loadCustomDiscPreviewContainer = document.getElementById(
          "load-custom-disc-preview-container"
        );
        let errorMessageConatiner =
          document.getElementById("load-design-error");
        let successMessageConatiner = document.getElementById(
          "load-design-success"
        );

        loadCustomDiscPreviewContainer.classList.add("no-event");

        const { status, message } = await deleteDesign(id);

        successMessageConatiner.innerHTML = "";
        errorMessageConatiner.innerHTML = "";
        if (status === true) {
          successMessageConatiner.innerHTML = message;
          wrapper.remove(); // Remove from DOM
        } else {
          errorMessageConatiner.innerHTML = message;
        }
        window.setTimeout(function () {
          successMessageConatiner.innerHTML = "";
          errorMessageConatiner.innerHTML = "";
          loadCustomDiscPreviewContainer.classList.remove("no-event");
        }, 2500);
      });
      wrapper.appendChild(checkbox);
      wrapper.appendChild(img);
      wrapper.appendChild(delBtn);
      container.appendChild(wrapper);
    });
  }
  loadPreviousDesign(window.previousDesigns);
  window.loadPreviousDesign = loadPreviousDesign;

  async function deleteDesign(designId) {
    let customerEmail = window.ShopifyCustomerEmail;

    let encodedData = btoa(
      JSON.stringify({ customerEmail: customerEmail, designId })
    );

    try {
      const payload = {
        encodedData: encodedData,
        designId: designId,
      };

      const response = await fetch(
        `${DGSAppBaseUrl}/disc-designs/delete-design`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) throw new Error(`Server error: ${response.status}`);

      const { status, message } = await response.json();
      let returnResponse = {
        status: status,
        message: message,
      };
      return returnResponse;
    } catch (err) {
      return {
        status: false,
        message: err.message || "❌ Failed to delete design",
      };
    }
  }

  bulkDesignDeleteBtn.addEventListener("click", bulkDesignDeleteSelected);

  // Bulk delete function
  async function bulkDesignDeleteSelected() {
    if (selectedDesignsForDeletion.length === 0) {
      alert("Select at least one design to delete.");
      return;
    }

    if (!confirm("Are you sure you want to delete selected designs?")) return;

    const loadCustomDiscPreviewContainer = document.getElementById(
      "load-custom-disc-preview-container"
    );
    loadCustomDiscPreviewContainer.classList.add("no-event");

    const successMessageConatiner = document.getElementById(
      "load-design-success"
    );
    const errorMessageConatiner = document.getElementById("load-design-error");
    successMessageConatiner.innerHTML = "";
    errorMessageConatiner.innerHTML = "";

    let deletedCount = 0;
    let failedCount = 0;

   for (const designId of selectedDesignsForDeletion) {
      try {
        const { status, message } = await deleteDesign(designId);

        if (status) {
          deletedCount++;

          const wrapper = document.querySelector(
            `.preview-image-wrapper input[value="${designId}"]`
          )?.parentElement;
          wrapper?.remove();
        } else {
          failedCount++;
          console.error(`Failed to delete design ${designId}: ${message}`);
        }
      } catch (err) {
        failedCount++;
        console.error(`Error deleting design ${designId}:`, err);
      }
    }

    document.querySelectorAll(".design-checkbox").forEach((cb) => {
      cb.checked = false;
    });


    if (selectedDesignsForDeletion.length === deletedCount) {
      bulkDesignDeleteBtn.classList.remove("active");
    }

    successMessageConatiner.innerHTML = `Deleted ${deletedCount} design(s)`;
    if (failedCount) {
      errorMessageConatiner.innerHTML = `${failedCount} design(s) failed to delete`;
    }

    selectedDesignsForDeletion = []; // reset selection
    setTimeout(() => {
      successMessageConatiner.innerHTML = "";
      errorMessageConatiner.innerHTML = "";
      loadCustomDiscPreviewContainer.classList.remove("no-event");
    }, 2500);
  }
});
